import React from 'react'
import PropTypes from 'prop-types'
import { isProd, getENV } from 'tools/env'

const settings = {
  BONUS_BOX_OFFER_PUBLIC_ID: 'onus-promo-code',
  WALLET_URI: isProd() ? 'https://wallet.fanball.com' : 'https://wallet-qa.shub.dog',
  WALLET_API_URI: isProd() ? 'https://wallet.fanball.com/api/graphql' : 'https://wallet-qa.shub.dog/api/graphql',
  DEFAULT_AVATAR_IMAGE: 'https://assets.fanball.com/img/default-user.png',
  CONNECT_SUBSCRIPTIONS_URI: isProd()
    ? 'wss://connect.shgn.com/connect/subscriptions'
    : 'wss://connect-qa.shub.dog/connect/subscriptions',
  CONNECT_API_URI: isProd()
    ? 'https://connect.shgn.com/connect/api/graphql'
    : 'https://connect-qa.shub.dog/connect/api/graphql',
  ACCOUNT_SETTINGS_URL: isProd()
    ? 'https://wallet.fanball.com/account-settings'
    : 'https://wallet-qa.shub.dog/account-settings',
  HOSTNAME: getENV(),
}

const { Provider, Consumer } = React.createContext()

const SettingsConsumer = Consumer

class SettingsProvider extends React.Component {
  render() {
    return (
      <Provider
        value={{
          ...settings,
        }}
      >
        {this.props.children}
      </Provider>
    )
  }
}

export { SettingsProvider, SettingsConsumer, settings }

SettingsProvider.propTypes = {
  children: PropTypes.node.isRequired,
}



// WEBPACK FOOTER //
// ./src/contexts/settings-context.js